import { Spinner } from '@/shared/ui/spinner';
import { cn } from '@/lib/utils';

/**
 * The waiting state for a whole page or panel.
 *
 * `label` is read by screen readers - a spinning graphic conveys nothing
 * without it.
 */
export function LoadingScreen({
  label = 'Loading',
  className,
  full = false,
}: {
  label?: string;
  className?: string;
  full?: boolean;
}) {
  return (
    <div
      className={cn(
        'flex items-center justify-center gap-3 text-muted-foreground',
        full ? 'min-h-dvh' : 'min-h-48',
        className,
      )}
    >
      <Spinner className="size-5" aria-label={label} />
      <span className="text-sm">{label}</span>
    </div>
  );
}
